module.exports = [
    {
        numero: 2,
        iva:' N/A',
    },
    {
        numero: 3,
        iva:' N/A',
    },
    {
        numero: 4,
        iva:' N/A',
    },
    {
        numero: 5,
        iva:'N/A',
    },
    {
        numero: 6,
        iva:'N/A',
    },
    {
        numero: 7,
        iva:'N/A',
    },
    {
        numero: 8,
        iva:'N/A',
    },
    {
        numero: 9,
        iva:'8%',
    },
    
    {
        numero: 10,
        iva:'8%',
    },
    
    {
        numero: 11,
        iva:'8%',
    },
    {
        numero: 12,
        iva:'N/A',
    },
    {
        numero: 13,
        iva:'8%',
    },
    
    {
        numero: 14,
        iva:'8%',
    },
    
    {
        numero: 15,
        iva:'8%',
    },
    {
        numero: 16,
        iva:'8%',
    },
    
    {
        numero: 17,
        iva:'N/A',
    },
    
    {
        numero: 18,
        iva:'N/A',
    },
    
    {
        numero: 19,
        iva:'N/A',
    },
    
    {
        numero: 20,
        iva:'N/A',
    },
    
    {
        numero: 21,
        iva:'N/A',
    },
    
    {
        numero: 22,
        iva:'N/A',
    },
    
    {
        numero: 23,
        iva:'N/A',
    },
    
    {
        numero: 24,
        iva:'N/A',
    },
    
    {
        numero: 25,
        iva:'8%',
    },
    
    {
        numero: 26,
        iva:'N/A',
    },
    
    {
        numero: 27,
        iva:'N/A',
    },
    
    {
        numero: 28,
        iva:'N/A',
    },
    
    {
        numero: 29,
        iva:'8%',
    },
    
    {
        numero: 30,
        iva:'N/A',
    },
    
    {
        numero: 31,
        iva:'8%',
    },
    
    {
        numero: 32,
        iva:'8%',
    },

    {
        numero: 33,
        iva:'N/A',
    },
    
    {
        numero: 34,
        iva:'8%',
    },
    
    {
        numero: 35,
        iva:'8%',
    },
    
    {
        numero: 36,
        iva:'8%',
    },
    {
        numero: 37,
        iva:'8%',
    },
    
    {
        numero: 38,
        iva:'8%',
    },
    
    {
        numero: 39,
        iva:'8%',
    },
    
    {
        numero: 40,
        iva:'8%',
    },
    {
        numero: 41,
        iva:'8%',
    },
    
    {
        numero: 42,
        iva:'8%',
    },
    
    {
        numero: 43,
        iva:'8%',
    },
    
    {
        numero: 44,
        iva:'8%',
    },
    {
        numero: 45,
        iva:'8%',
    },
    
    {
        numero: 46,
        iva:'N/A',
    },
    
    {
        numero: 47,
        iva:'8%',
    },
    
    {
        numero: 48,
        iva:'8%',
    },
    {
        numero: 49,
        iva:'8%',
    },
    
    {
        numero: 50,
        iva:'8%',
    },
    
    {
        numero: 51,
        iva:'8%',
    },
    
    {
        numero: 52,
        iva:'8%',
    },
    {
        numero: 53,
        iva:'8%',
    },
]


// WEBPACK FOOTER //
// ./src/utils/expoIva.js